import axios from 'axios';
import { X_API_KEY } from '../utils/authentication';
import i18n from '../i18n';

const apiVersion = "v1"
// from the root of the site
let apiUrl = `${window.location.origin}/ddstore/api/${apiVersion}`;

const devicesAction = "ddinfos";
const deviceAction = "ddinfo";
const downloadXmlAction = "ddfile";
const pictureAction = "pictures";
const thumbnailAction = "pictures/thumb";

export function getApiBaseUrl() {
    return apiUrl;
}

export function getDevicesApiUrl() {
    return `${getApiBaseUrl()}/${devicesAction}?offset=-1&scope=cloud`;
}

export function searchDevicesApiUrl(searchString, filterObject, scope) {
    return `${getApiBaseUrl()}/${devicesAction}?offset=-1&search=${searchString}&filter=${filterObject.toString()}&scope=${scope}`;
}

export function getDeviceApiUrl(deviceId) {
    return `${getApiBaseUrl()}/${deviceAction}/${deviceId}`;
}

export function getPictureApiUrl(picRef) {
    return `${getApiBaseUrl()}/${pictureAction}/${picRef}`;
}

export function getThumbnailApiUrl(picRef) {
    return `${getApiBaseUrl()}/${thumbnailAction}/${picRef}`;
}

export function getXmlApiUrl(xmlRef) {
    return `${getApiBaseUrl()}/${downloadXmlAction}/${xmlRef}`;
}

const instance = axios.create({
});

instance.interceptors.request.use(config => {
    if (localStorage.getItem(X_API_KEY) !== null && typeof localStorage.getItem(X_API_KEY) === 'string' && localStorage.getItem(X_API_KEY) !== '') {
        config.headers['X-API-KEY'] = localStorage.getItem(X_API_KEY);
        config.headers['X-LANG'] =  i18n.language;
    } else {
        delete config.headers['X-API-KEY'];
        config.headers['X-LANG'] =  i18n.language;
    }
    return config;
});

export default instance;
